import { render, staticRenderFns } from "./OldMatterProgram.vue?vue&type=template&id=fcb4af76&scoped=true"
import script from "./OldMatterProgram.vue?vue&type=script&lang=js"
export * from "./OldMatterProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb4af76",
  null
  
)

export default component.exports